import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import datePicker from '../../component/datePicker.vue'
import GenerateButton from './warehouseman_generate_button.vue'
import moment from 'moment'
import * as toastr from 'toastr'

require('bootstrap')

if ($('#plan_generate').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#plan_generate',
    components: {
      datePicker,
      GenerateButton,
    },
    mixins: [mixins],
    data: {
      date: moment().locale('pl').format('YYYY-MM-DD'),
      canGenerate : false,
      checkResults: [],
    },
    methods: {
      check() {
        $('#button_check').button('loading')
        let date = this.getDayBefore()
        let url = Routing.generate('api_get_plan_check', { 'date' : date })
        this.loading++
        this.$http.get(url).then(response => {
          this.checkResults = response.data
          this.loading--
          $('#button_check').button('reset')
          $('#checkModal').modal()
        }, response => {
          $('#button_check').button('reset')
          this.handleAjaxError(response)
        })
      },
      generate() {
        $('#button_generate').button('loading')
        let date = this.getDayBefore()
        let url = Routing.generate('api_get_plan_generate', { 'date' : date })
        this.$http.get(url).then(() => {
          toastr.success(Translator.trans('plan.generated'))
          $('#button_generate').button('reset')
          $('#checkModal').modal('hide')
        }, response => {
          $('#button_generate').button('reset')
          switch (response.code) {
            case 425:
              toastr.error(response.data)
              return
            default:
              toastr.error(Translator.trans('plan.generated_error'))
          }

        })
      },
      remove() {
        $('#button_remove').button('loading')
        let date = this.getDayBefore()
        let url = Routing.generate('api_get_plan_remove', { 'date' : date })
        this.$http.get(url).then(() => {
          toastr.success(Translator.trans('plan.removed'))
          $('#button_remove').button('reset')
          $('#checkModal').modal('hide')

        }, () => {
          toastr.error(Translator.trans('plan.removed_error'))
          $('#button_remove').button('reset')
        })
      },
      getDayBefore() {
        let date = moment(this.date, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD')

        return date
      }
    },
  })
}
